import http, { encode } from './index';

export const updateMvLicence = async (company, siteId, action) =>
  http.post(`/companies/${encode(company)}/sites/${encode(siteId)}/services/MOBILE_VIDEO/licence`, action);

export const activateActivationCode = async (companyId, siteId, code) =>
  http.post(`/promo/codes/${encode(code)}/activation`, {
    companyId,
    siteId,
  });

export const getVatVerification = async (companyId) => http.head(`/companies/${encode(companyId)}/purchase/vat`);
